import { ID } from "@/types/common"

/**
 * 学生状态枚举：用于约束状态字段与下拉选项来源
 */
export enum StudentStatus {
  /** 干预中 */
  INTERVENING = 1,
  /** 已离园 */
  LEFT = 2,
}

/**
 * 学生实体接口
 * API 返回/页面表格展示的完整学生实体
 */
export interface Student {
  /** 学生ID */
  id: ID
  /** 学生姓名 */
  name: string
  /** 学生状态 */
  status: StudentStatus
  /** 备注信息 */
  note?: string
  /** 生日 */
  birthday?: string
}

/**
 * 学生表单数据接口
 * 表单提交用的数据结构（不包含只读/派生字段）
 */
export interface StudentFormData {
  /** 学生姓名 */
  name: string
  /** 学生状态 */
  status: StudentStatus
  /** 备注信息 */
  note?: string
  /** 生日 */
  birthday?: string
}

/**
 * 学生表格组件属性接口
 */
export interface StudentTableProps {
  /** 学生列表数据 */
  students: Student[]
  /** 编辑学生回调函数 */
  onEdit: (student: Student) => void
  /** 删除学生回调函数 */
  onDelete: (id: Student["id"]) => void
  /** 加载状态 */
  loading?: boolean
  /** 已选中的学生ID列表 */
  selectedIds?: Array<Student["id"]>
  /** 选择变化回调函数 */
  onSelectionChange?: (selectedIds: Array<Student["id"]>) => void
  /** 分页信息 */
  pagination?: {
    page: number
    pageSize: number
    total: number
  }
  /** 分页变化回调 */
  onPageChange?: (page: number, pageSize: number) => void
}

/**
 * 学生信息弹窗组件属性接口
 */
export interface StudentModalProps {
  /** 弹窗是否打开 */
  isOpen: boolean
  /** 当前编辑的学生信息，为null时表示新增 */
  student: Student | null
  /** 提交加载状态 */
  loading: boolean
  /** 关闭回调函数 */
  onClose: () => void
  /** 保存回调函数 */
  onSave: (data: StudentFormData) => void
}
